/**
 * Layout.jsx
 * 
 * Main layout wrapper for HemaAI V2.0
 * Wraps pages with Header, Footer, and common providers
 * 
 * @author Dr. Omokayode Aderolu
 * @company OmniAlera Technologies Holdings Inc.
 * @version 2.0.0
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { Toaster } from 'react-hot-toast';

const Layout = ({ hideHeader = false, hideFooter = false, fullWidth = false }) => {
  return (
    <div className="min-h-screen flex flex-col app-bg">
      {/* Toast Notifications */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1f2937',
            color: '#fff',
            borderRadius: '12px',
            padding: '16px',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />

      {/* Header */}
      {!hideHeader && <Header />}

      {/* Main Content */}
      <main className={`flex-1 ${fullWidth ? '' : 'max-w-7xl mx-auto w-full px-4 py-8'}`}>
        <Outlet />
      </main>

      {/* Footer */}
      {!hideFooter && <Footer />}
    </div>
  );
};

export default Layout;
